<ng-template #contentHeaderTemplate>
  @if (employee) {
    <div class="row">
      <div class="col-12 d-flex justify-content-end ">
        <button class="btn btn-primary" (click)="save()">
          {{ 'misc.save_btn' | translate }}
        </button>
      </div>
    </div>
  }
</ng-template>

@if (employee) {

  <div class="row g-3">

    <div class="col-12 col-md-9 order-md-1">
      <form [formGroup]="form" (submit)="save()">
        <div class="card mb-3">
          <div class="card-header">
            {{ 'authenticated.time_tracking.employees.edit.header' | translate }}
          </div>
          <div class="card-body">

            <div class="row">

              <div class="col-12 col-lg-6 py-1">
                <app-form-group
                  [formControl]="readonlyForm.controls.name"
                  label="{{'authenticated.time_tracking.employees.edit.form.name.label' | translate }}"
                ></app-form-group>
              </div>

              <div class="col-12 col-lg-6 py-1">
                <app-form-group
                  [formControl]="readonlyForm.controls.email"
                  label="{{'authenticated.time_tracking.employees.edit.form.email.label' | translate }}"
                ></app-form-group>
              </div>

              <div class="col-12 col-lg-6 py-1">
                <app-multi-select-enum
                  [enum]="GermanStateEnum"
                  [formControl]="form.controls.federal_state"
                  label="{{'authenticated.time_tracking.employees.edit.form.federal_state.label' | translate }}"
                  translateKey="germanStateEnum"
                  [multi]="false"
                ></app-multi-select-enum>
              </div>

              <div class="col-12 col-lg-6 py-1">
                <app-date-time
                  [formControl]="form.controls.entry_date"
                  label="{{'authenticated.time_tracking.employees.edit.form.entry_date.label' | translate }}"
                ></app-date-time>
              </div>

              <div class="col-12 col-lg-6 py-1">

                <app-multi-select-with-service
                  [service]="addableTeamLeadersService"
                  searchOnField="name"
                  sort="name"
                  [formControl]="form.controls.team_leader_id"
                  selectionMode="single_id"
                  label="{{'authenticated.time_tracking.employees.edit.form.team_leader_id.label' | translate }}"
                ></app-multi-select-with-service>

              </div>

            </div>
          </div>
        </div>
      </form>

      <app-authenticated-time-tracking-employees-edit-weekly-working-hours
        [employee]="employee"
      ></app-authenticated-time-tracking-employees-edit-weekly-working-hours>

      <app-authenticated-time-tracking-employees-edit-yearly-vacation-days
        [employee]="employee"
      ></app-authenticated-time-tracking-employees-edit-yearly-vacation-days>
    </div>
  </div>
}
